import { useState } from 'react';
import useDataService from '../../hooks/useDataService';
import { eMessageType } from '../../types/IMessageType';
import { checkForSuccesInvocation } from '../../_lib/utils';
import { useConfirm } from '../../context/ConfirmContext';
import { executeVerticalSyncV3, fetchSchemaReviewV3, fetchSchemaApprovalV3 } from './verticalSyncV3Api';
import { ISchemaSyncProps } from './types';

const useVerticalSyncV3 = ({ syncFor }: ISchemaSyncProps) => {
  const { confirm } = useConfirm();
  const [environment, setEnvironment] = useState('');
  const [release, setRelease] = useState('');
  const [tenantId, setTenantId] = useState('');
  const [processState, setProcessState] = useState<number>(0);
  const [previewState, setPreviewState] = useState<any>(null);
  const [reviewQueriesConfirmationDialog, setReviewQueriesConfirmationDialog] = useState<boolean>(false);
  const [reviewData, setReviewData] = useState<any>({ queryData: null });
  const { openSnackBar } = useDataService();

  const isTransactionPerTenant = release.toLowerCase().includes('transactionpertenant');
  const type = isTransactionPerTenant ? 'TransactionPerTenant' : undefined;

  const schemaSync = async () => {
    setProcessState(1);
    const res: any = await executeVerticalSyncV3(syncFor, environment, release, type, tenantId);
    if (!res.error) {
      try {
        checkForSuccesInvocation(res, setPreviewState, setProcessState);
      } catch (e: any) {
        openSnackBar(e.message || 'Something went wrong, Unable to check status', eMessageType.error);
      }
    } else {
      setProcessState(0);
      setPreviewState(null);
      openSnackBar('Vertical Sync Failed', eMessageType.error);
    }
  };

  const openReviewQueriesConfirmationDialog = async () => {
    setReviewQueriesConfirmationDialog(true);
    setReviewData({ queryData: null });
    const res: any = await fetchSchemaReviewV3(environment, release, type);
    if (!res.error) {
      setReviewData({
        queryData: Array.isArray(res.queries) ? res.queries : [],
        currentTotalApprovers: res.currentTotalApprovers,
        currentlyApprovedBy: res.currentlyApprovedBy,
        newQueriesCount: res.newQueriesCount,
      });
    } else {
      openSnackBar(res.message || 'Failed to fetch queries', eMessageType.error);
      closeReviewQueriesConfirmationDialog();
    }
  };

  const closeReviewQueriesConfirmationDialog = () => {
    setReviewQueriesConfirmationDialog(false);
    setReviewData({ queryData: null });
  };

  const onApprove = async () => {
    const res: any = await fetchSchemaApprovalV3(environment, release, type);
    if (!res.error) {
      openSnackBar(res.message || 'Queries approved successfully', eMessageType.success);
    } else {
      openSnackBar(res.message || 'Approve queries failed', eMessageType.error);
    }
  };

  return {
    environment, setEnvironment, release, setRelease, tenantId, setTenantId,
    isTransactionPerTenant, processState, setProcessState, previewState,
    reviewQueriesConfirmationDialog, reviewData, schemaSync,
    openReviewQueriesConfirmationDialog, closeReviewQueriesConfirmationDialog, onApprove, confirm,
  };
};

export default useVerticalSyncV3;
